// extracted by mini-css-extract-plugin
export var leftAlign = "_23-2";
export var popper = "_23-0";
export var subtitle = "_23-1";